module.exports = __webpack_public_path__ + "static/media/cart.5620d8bd.svg";